interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  level?: 2 | 3;
}

export default function SectionHeading({ eyebrow, title, desc, align = "left", level = 2 }: SectionHeadingProps) {
  const Tag = (level === 2 ? "h2" : "h3") as "h2" | "h3";
  const alignClass = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";

  return (
    <div className={`flex max-w-2xl flex-col ${alignClass}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 font-label text-xs font-medium uppercase tracking-widest text-primary-700">
          <span className="h-px w-6 bg-primary-400" />
          {eyebrow}
        </span>
      )}
      <Tag className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[1.75rem]">
        {title}
      </Tag>
      {desc && <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}